import React, { Component } from 'react';
import { Modal, Col, Row } from 'react-bootstrap';
import Button from 'react-bootstrap-button-loader';
import { connectModal } from 'redux-modal';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { convertCentsToDollars, currencyFormat } from '../../../utils/helpers/currency';

class InvoicesPopup extends Component {

  render() {
    const { show, invoice, handleHide } = this.props;
    const invoiceItems = invoice.lines.data;

    const invoiceBold = {
      fontWeight: '900'
    };
    const fontSizeLrg = {
      fontSize: '2em'
    };
    const stampStyles = {
      fontSize: '1.3em',
      textAlign: 'center',
      borderRadius: '10px',
      display: 'inline-block',
      padding: '8px',
      fontWeight: '800',
      textTransform: 'uppercase',
      letterSpacing: '4px'
    };

    const paidStamp = (
      <div className='paid-stamp' style={{ ...stampStyles, color: 'green', border: '3px solid green', }}>Paid</div>
    );

    const unpaidStamp = (
      <div className='paid-stamp' style={{ ...stampStyles, color: 'red', border: '3px solid red', }}>Unpaid</div>
    );

    return (
      <Modal show={show} onHide={handleHide}>
        <Modal.Header>
          <Modal.Title>Invoice #{invoice.number}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={8}><span className='invoice-company-name' style={fontSizeLrg}>1902063 Ontario Ltd</span></Col>
            <Col sm={4}>{['open', 'draft'].includes(invoice.status) ? unpaidStamp : paidStamp}</Col>
          </Row>
          <br />
          <Row>
            <Col sm={12}>
              <Row>
                <Col sm={3}><span className='invoice-number' style={invoiceBold}>Invoice number</span></Col>
                <Col sm={9}>{invoice.number}</Col>
              </Row>
              <Row>
                <Col sm={3}><span className='invoice-number' style={invoiceBold}>Date of issue</span></Col>
                <Col sm={9}> {moment.unix(invoice.date).format('MMM Do, YYYY')}</Col>
              </Row>
            </Col>
          </Row>
          <br />
          <Row>
            <Col xs={12}>
              <ul style={{ listStyle: 'none', padding: '0' }}>
                <li style={invoiceBold}>Bill to</li>
                <li>{invoice.customer_description}</li>
                <li>{invoice.email}</li>
              </ul>
            </Col>
          </Row>
          <br />
          <div className="react-bs-container-body">
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {invoiceItems.map((item, i) => {
                  return (
                    <tr key={i}>
                      <td className='col-xs-9'>{item.description}</td>
                      <td className='col-xs-3'>{currencyFormat(convertCentsToDollars(item.amount))}</td>
                    </tr>
                  );
                })}

                <tr>
                  <td className='text-right col-xs-9' style={invoiceBold}>Subtotal</td>
                  <td className='col-xs-3' style={{ backgroundColor: 'rgba(134,180,227,0.2' }}>
                    {currencyFormat(convertCentsToDollars(invoice.total))}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br />
          <hr />
          {
            ['open', 'paid'].includes(invoice.status) && (
              <Row>
                <Col xs={12}><a href={invoice.invoice_pdf}><FontAwesomeIcon icon="file-pdf" /> Download PDF</a></Col>
              </Row>
            )
          }
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const InvoiceModal = connectModal({
  name: 'InvoiceModal'
});

export default InvoiceModal(InvoicesPopup);
